export default __webpack_public_path__ + "static/media/facebook.8d4eb0b6.svg";